export default {
  currentTicket: null,
  inviteTeamInfo: {},
  attendees: [],
};
